<template>
    <!-- TODO: Footer -->
    <footer class="p-10 2xl:px-96 bg-hijau">
        <div class="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-4 gap-4 pb-16 text-white">
            <div class="text-center">
                <img src="https://i.ibb.co/qrV8bvs/pth-KOTA-SAMARINDA.png" alt="Logo" class="w-56 h-auto mx-auto">
                <h3 class="uppercase font-bold">Baznas Samarinda</h3>
                <p class="text-xs">
                    Alamat: Jl. Dahlia No. 02 (Komplek Balaikota) Kel. Bugis, Samarinda Kode Pos 75121
                </p>
                <p class="text-xs">
                    Email: baznaskota.samarinda@baznas.go.id
                </p>
                <p class="text-xs">
                    Telepon: 0811-5546-000
                </p>
            </div>
            <div class="">
                <h3 class="uppercase font-bold mb-3 pb-3 border-b-2">Tentang Kami</h3>
                <ul>
                    <li class="py-3"><router-link :to="{name: 'profil'}">Profil</router-link></li>
                    <li class="py-3"><router-link :to="{name: 'hubungiKami'}">Kontak Kami</router-link></li>
                    <li class="py-3"><a href="http://pid.baznas.go.id/peraturan/">Perundang-undangan</a></li>
                    <li class="py-3"><router-link :to="{name: 'laporan'}">Laporan Keuangan</router-link></li>
                </ul>
            </div>
            <div class="">
                <h3 class="uppercase font-bold mb-3 pb-3 border-b-2">Sosial Media</h3>
                <ul>
                    <li class="py-3"><a href="https://www.facebook.com/baznassamarinda/"><i class="fab fa-facebook pl-2" ></i> Facebook</a></li>
                    <li class="py-3"><a href="https://www.instagram.com/baznas.samarinda/"><i class="fab fa-instagram pl-2" ></i>Instagram</a></li>
                </ul>
            </div>
            <div class="">
                <h3 class="uppercase font-bold mb-3 pb-3 border-b-2">Zakat</h3>
                <ul>
                    <li class="py-3"><router-link :to="{name: 'campaign.show', params:{slug: 'zakat-mal'}}">Zakat Maal</router-link></li>
                    <li class="py-3"><router-link :to="{name: 'campaign.show', params:{slug: 'zakat-penghasilan'}}">Zakat Penghasilan</router-link></li>
                    <li class="py-3"><router-link :to="{name: 'campaign.show', params:{slug: 'infaq'}}">Infaq</router-link></li>
                    <li class="py-3"><router-link :to="{name: 'category.show', params:{slug: 'donasi'}}">Donasi</router-link></li>
                </ul>
            </div>
        </div>
    </footer>
</template>

<script>
export default {

}
</script>

<style>

</style>